/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import {
    Checkbox,
    FormGroup,
    FormControlLabel,
    Tooltip,
    CircularProgress,
} from '@material-ui/core'

import moment from 'moment'
import keysMapper from './keysMapper'

import updateMessage from './actions'

import SuccessIcon from './Icons/successIcon'
import FailIcon from './Icons/failIcon'
import ReplaceIcon from './Icons/replaceIcon'
import JunkIcon from './Icons/junkIcon'
import SendIcon from './Icons/sendIcon'

import AppointmentEditor from './Actions/Appointment'
import ConfirmSend from './ConfirmSend'
import ConfirmHTO from './ConfirmHTO'

import './index.scss'

const weekdayIndexMap = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
}

const GreenCheckbox = withStyles({
    root: {
        color: '#66bb6a',
        '&$checked': {
            color: '#43a047',
        },
    },
})(props => <Checkbox size='small' color='default' {...props} />)

const onPasteEvent = event => {
    const paste = (event.clipboardData || window.clipboardData).getData('text')

    const selection = window.getSelection()

    const stringified = document.createTextNode(paste)

    if (!selection.rangeCount) return false
    selection.deleteFromDocument()
    selection.getRangeAt(0).insertNode(stringified)

    event.preventDefault()
}

class OperatorEditBox extends React.Component {
    static get defaultProps() {
        return {
            messageToEdit: {},
        }
    }

    constructor(props) {
        super(props)

        this.state = {
            messageId: '',
            initialMessage: '',
            oldMessage: '',
            oldMessageHTML: '',
            shouldSave: true,
            confirmHTOModal: false,
        }

        this.editableDivRef = React.createRef()

        this.handleOnInput = this.handleOnInput.bind(this)
        this.onAppointmentEditorClose = this.onAppointmentEditorClose.bind(this)
        this.onAppointmentUpdate = this.onAppointmentUpdate.bind(this)
        this.onClickSend = this.onClickSend.bind(this)
        this.handleConfirmClose = this.handleConfirmClose.bind(this)
        this.handleConfirmHTOModal = this.handleConfirmHTOModal.bind(this)
    }

    componentDidUpdate(oldProps) {
        if (JSON.stringify(oldProps) === JSON.stringify(this.props)) {
            return
        }

        const { sent } = this.props

        if (!oldProps.sent && sent) {
            this.props.onMessageSent()

            return
        }

        const { messageToEdit = {} } = this.props
        const { messageToEdit: currMessageToEdit = {} } = this.state

        if (
            JSON.stringify(messageToEdit.MessageId) !== JSON.stringify(currMessageToEdit.MessageId)
        ) {
            const oldMessageHTML = messageToEdit.MessageHTML
            const oldMessage = messageToEdit.Message

            this.setState({
                oldMessage,
                oldMessageHTML,
                messageToEdit: { ...messageToEdit },
                messageId: messageToEdit.MessageId,
                initialMessage:
                    messageToEdit.MessageHTML || messageToEdit.Message,
            })
        }
    }

    handleOnInput() {
        const { messageToEdit } = this.state

        // Disable takeover, operator is typing

        // if (messageToEdit.RequiresHumanTakeover) {
        //     messageToEdit.RequiresHumanTakeover = false
        // }

        messageToEdit.MessageHTML = this.editableDivRef.current.innerHTML
        messageToEdit.Message = this.editableDivRef.current.innerText

        this.setState({ messageToEdit })
    }

    updateMessage(doNotSend = false) {
        const { loading } = this.props
        const { messageToEdit, oldMessage, oldMessageHTML } = this.state

        let newMessage
        if (messageToEdit.Channel === 'email') {
            newMessage = this.editableDivRef.current.innerHTML
        } else {
            newMessage = this.editableDivRef.current.innerText
        }

        messageToEdit.MessageHTML = newMessage
        messageToEdit.Message = newMessage

        const username = localStorage.getItem(
            'pulsarBotPlatform_operatorUsername'
        )

        // eslint-disable-next-line no-param-reassign
        messageToEdit.EditedBy = username
        messageToEdit.Edited = true

        messageToEdit.OldMessage = oldMessage
        messageToEdit.OldMessageHTML = oldMessageHTML

        if (!loading) {
            const isExpanded = false

            this.props.updateMessage(messageToEdit, doNotSend)

            this.props.toggleExpanded(isExpanded)

            this.setState({
                messageId: '',
                initialMessage: '',
                oldMessage: '',
                oldMessageHTML: '',
                messageToEdit: undefined,
                isExpanded,
            })
        }
    }

    setHumanTakeover() {
        const { messageToEdit } = this.state

        if (!messageToEdit) {
            return
        }

        messageToEdit.RequiresHumanTakeover = !messageToEdit.RequiresHumanTakeover

        this.setState({ messageToEdit }, () => {
            this.toggleToolsPopup()
        })
    }

    handleHumanTakeOverAndMessageUpdate() {
        const { messageToEdit } = this.state

        const { AppointmentData } = messageToEdit
        // if (this.props.accountId === 'shift') {
        //     this.updateMessage()
        //     return
        // }
        if (AppointmentData) {
            messageToEdit.RequiresHumanTakeover = true
            messageToEdit.HTO = true
            // messageToEdit.ForceSendNotifications = true
            this.openConfirmDialog()
            return
        }
        messageToEdit.RequiresHumanTakeover = true
        messageToEdit.HTO = true
        // messageToEdit.ForceSendNotifications = true

        const doNotSend = true
        this.updateMessage(doNotSend)
    }

    handleConfirmHTOModal = confirm => {
        const { confirmHTOModal } = this.state
        this.setState({ confirmHTOModal: !confirmHTOModal })
        if (confirm) {
            this.handleHumanTakeOverAndMessageUpdate()
        }
    }

    toggleToolsPopup() {
        const { toolsPopupIsOpen } = this.state

        this.setState({ toolsPopupIsOpen: !toolsPopupIsOpen })
    }

    replaceDynamicVariablesWithValues() {
        const {
            threadDetails,
            threadDetailsLoading,
            userDetailsLoading,
            userDetails,
        } = this.props

        if (threadDetailsLoading || !threadDetails || userDetailsLoading) {
            return
        }

        const carInformation = threadDetails.rawResponse
        let extractedMessage = this.editableDivRef.current.innerHTML

        const matches = extractedMessage.match(/\${[A-z]+}/g)

        if ('Name' in userDetails) {
            extractedMessage = extractedMessage.replace(
                '[Name]',
                userDetails.Name
            )
        }

        if (matches) {
            matches.forEach(match => {
                const key = match.replace('${', '').replace('}', '')
                const mappedKey = keysMapper[key]
                if (mappedKey in carInformation) {
                    extractedMessage = extractedMessage.replace(
                        match,
                        carInformation[mappedKey]
                    )
                }
            })
        }

        this.editableDivRef.current.innerHTML = extractedMessage
    }

    onAppointmentEditorClose() {
        this.setState({
            appointmentEditorOpened: false,
            toolsPopupIsOpen: false,
        })
    }

    onAppointmentUpdate(data) {
        const { messageToEdit } = this.state

        if (!data) {
            delete messageToEdit.AppointmentData
        } else {
            messageToEdit.AppointmentData = JSON.stringify(data)
        }

        console.log('\n\n\n\nUPDATED!', messageToEdit)

        this.setState({ messageToEdit })

        this.onAppointmentEditorClose()
    }

    onClickSend() {
        const { messageToEdit } = this.state

        if (!messageToEdit) {
            return
        }

        const { AppointmentData } = messageToEdit
        // if (this.props.accountId === 'shift') {
        //     this.updateMessage()
        //     return
        // }
        if (AppointmentData) {
            this.setState({ shouldSave: false })
            this.openConfirmDialog()

            return
        }

        this.updateMessage()
    }

    openConfirmDialog() {
        this.setState({ confirmDialogIsOpen: true })
    }

    closeConfirmDialog() {
        this.setState({ confirmDialogIsOpen: false })
    }

    handleConfirmClose(confirm) {
        this.closeConfirmDialog()

        if (confirm) {
            this.updateMessage(this.state.shouldSave)
        }
    }

    // Appt checker
    timeInWorkingHours(appointmentDataAlt) {
        const { statusOn, statuses } = this.props
        if (
            statusOn
            && statusOn.show_status
            && statuses
            && statuses.length > 0
            && statuses[statuses.length - 1].Status
            && statusOn.status_map[statuses[statuses.length - 1].Status] === 'Do not set an appointment'
        ) {
            return false
        }

        const form = this.props.inputForm
        if (form && form.length) {
            const inputs = form.map(item => item.input)
            if (inputs.includes('phone')) {
                return true
            }
        }

        const accountInformation = this.props.settings?.account_information

        if (!accountInformation || !appointmentDataAlt) return true

        const { utc_offset: utcOffset, SpecificDates: specificDates } = accountInformation

        let workingHours = accountInformation.working_hours
        if ('appointment_hours' in accountInformation) {
            workingHours = accountInformation.appointment_hours
        }

        const { date, time } = appointmentDataAlt

        if (!date || !time) return true

        const currentDateValue = new Date(`${date}T${time}`)

        if (currentDateValue === 'Invalid Date') return false

        const localOffset = currentDateValue.getTimezoneOffset() / 60

        let dealerTime = new Date().getTime()
        dealerTime += localOffset * 60 * 60 * 1000
        dealerTime += utcOffset * 60 * 60 * 1000
        dealerTime = new Date(dealerTime)

        if (currentDateValue < dealerTime) {
            return false
        }

        if (!this.checkWeekday(currentDateValue, workingHours)) {
            return false
        }
        if (!this.checkSpecificDates(currentDateValue, specificDates)) {
            return false
        }

        return true
    }

    parseApptData(appointmentData) {
        if (!appointmentData) return {}
        const apptDataParsed = JSON.parse(appointmentData)
        const dateParsed = apptDataParsed.datetime
        const appointmentDataAlt = {}
        appointmentDataAlt.date = moment(dateParsed).format('YYYY-MM-DD')
        appointmentDataAlt.time = moment(dateParsed).format('HH:mm')
        return appointmentDataAlt
    }

    checkWeekday(date, workingHours) {
        if (!workingHours) {
            return true
        }

        const weekdayIndex = date.getDay()
        const weekday = weekdayIndexMap[weekdayIndex]
        const dayToCheck = workingHours[weekday]

        if (!dayToCheck) {
            return true
        }

        const { start, end, work_day: workDay } = dayToCheck

        if (!workDay) return false

        const startDate = new Date(date)
        const endDate = new Date(date)

        const startOptions = start.split(':')
        const endOptions = end.split(':')
        startDate.setHours(startOptions[0], startOptions[1], 0)
        endDate.setHours(endOptions[0], endOptions[1], 0)

        if (date < startDate || date > endDate) return false

        return true
    }

    checkSpecificDates(date, specificDates) {
        if (!specificDates || !specificDates.length) {
            return true
        }

        for (const specificDate of specificDates) {
            if (!this.checkSpecificDate(date, specificDate)) return false
        }

        return true
    }

    checkSpecificDate(date, specificDate) {
        const { Closed: closed, Date: specificDateItem } = specificDate

        if (closed === false) return true

        const currentDate = date.getDate().toString()
        const currentMonth = date.getMonth().toString()
        const currentYear = date.getFullYear().toString()

        const comparatorDate = specificDateItem.Day
        const comparatorMonth = specificDateItem.Month
        const comparatorYear = specificDateItem.Year

        if (
            String(currentYear) === String(comparatorYear)
            && String(this.formatSingleDigit(String(+currentMonth + 1))) === String(comparatorMonth)
            && String(this.formatSingleDigit(String(currentDate))) === String(comparatorDate)
        ) {
            return false
        }

        return true
    }

    formatSingleDigit(digitStr) {
        if (digitStr.length === 2) return digitStr

        // extra check
        const parsedDigit = Number(digitStr)
        if (parsedDigit > 9) return digitStr

        return `0${digitStr}`
    }

    render() {
        const { loading } = this.props
        const { initialMessage, messageToEdit, confirmHTOModal } = this.state

        const { toolsPopupIsOpen } = this.state

        const editBoxToolsClassnames = classNames({
            OperatorEditBox__tools_div: true,
            hasIssues: messageToEdit && messageToEdit.RequiresHumanTakeover,
            popupOpened: toolsPopupIsOpen,
        })

        const operatorEditBoxClassnames = classNames({
            OperatorEditBox: true,
            isExpanded: this.state.isExpanded,
        })

        return (
            <div className={operatorEditBoxClassnames}>
                {loading && (
                    <div className='loader'>
                        <CircularProgress />
                    </div>
                )}
                {!loading && messageToEdit && (
                    <div className='OperatorEditBox__wrapper'>
                        <div className='OperatorEditBox__timers'>
                            <div className='time'>{this.props.timers}</div>
                            <div
                                className='controls'
                                onClick={() => {
                                    const { isExpanded } = this.state

                                    const newValue = !isExpanded
                                    this.setState({ isExpanded: newValue })
                                    this.props.toggleExpanded(newValue)
                                }}
                            >
                                {this.state.isExpanded ? '↓' : '↑'}
                            </div>
                            {/* <div
                                className='controls'
                                onClick={() => {
                                    //
                                    let newStr =
                                        this.state.messageToEdit.MessageHTML
                                    let imagesDivStart = -1
                                    imagesDivStart = newStr.search(
                                        /<div class="carImgOuterWrapper"/
                                    )
                                    let imagesDivEnd =
                                        newStr.lastIndexOf('</div>')

                                    if (
                                        imagesDivStart !== -1 &&
                                        imagesDivEnd !== -1
                                    ) {
                                        let result = ''
                                        result += newStr.substring(
                                            0,
                                            imagesDivStart
                                        )
                                        result += newStr.substring(
                                            imagesDivEnd + 6
                                        )

                                        this.editableDivRef.current.innerHTML =
                                            result

                                        this.handleOnInput()
                                    }
                                }}
                            >
                                <span style={{ fontSize: '1.5vh' }}>
                                    clear media
                                </span>
                            </div> */}
                        </div>

                        <ConfirmSend
                            isOpen={this.state.confirmDialogIsOpen}
                            onClose={this.handleConfirmClose}
                            shouldSave={this.state.shouldSave}
                            timeInWorkingHours={() => this.timeInWorkingHours(
                                this.parseApptData(
                                    this.state.messageToEdit.AppointmentData
                                )
                            )
                            }
                        />

                        {confirmHTOModal && (
                            <ConfirmHTO
                                isOpen={this.state.confirmHTOModal}
                                onClose={this.handleConfirmHTOModal}
                            />
                        )}

                        <div
                            ref={this.editableDivRef}
                            spellCheck={false}
                            onInput={this.handleOnInput}
                            dangerouslySetInnerHTML={{ __html: initialMessage }}
                            onPaste={e => onPasteEvent(e)}
                            className='OperatorEditBox__editable-div'
                            contentEditable='false'
                        ></div>

                        <div className='OperatorEditBox__tools'>
                            <Tooltip title='Send message' placement='left'>
                                <div
                                    className='OperatorEditBox__send'
                                    disabled={
                                        messageToEdit.MessageHTML && loading
                                    }
                                    onClick={this.onClickSend}
                                >
                                    <SendIcon />
                                </div>
                            </Tooltip>

                            <Tooltip
                                title={
                                    messageToEdit.RequiresHumanTakeover
                                        ? 'Should be handled by human'
                                        : 'Everything OK'
                                }
                                placement='left'
                            >
                                <div
                                    onClick={() => this.toggleToolsPopup()}
                                    className={editBoxToolsClassnames}
                                >
                                    {messageToEdit.RequiresHumanTakeover ? (
                                        <FailIcon />
                                    ) : (
                                        <SuccessIcon />
                                    )}
                                </div>
                            </Tooltip>

                            {toolsPopupIsOpen && (
                                <div className='OperatorEditBox__tools__popup'>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <GreenCheckbox
                                                    checked={
                                                        messageToEdit.RequiresHumanTakeover || false
                                                    }
                                                    onChange={e => {
                                                        this.setHumanTakeover(
                                                            e.target.value
                                                        )
                                                    }}
                                                    value='checkedA'
                                                />
                                            }
                                            label='Human Takeover'
                                        />
                                    </FormGroup>
                                    <FormGroup row>
                                        <p
                                            className='appt-details'
                                            onClick={() => this.setState({
                                                appointmentEditorOpened: true,
                                            })
                                            }
                                        >
                                            <span>Appt Details</span>
                                        </p>
                                        {this.state.appointmentEditorOpened && (
                                            <AppointmentEditor
                                                onClose={
                                                    this
                                                        .onAppointmentEditorClose
                                                }
                                                appointmentData={
                                                    messageToEdit.AppointmentData
                                                }
                                                onAppointmentUpdate={
                                                    this.onAppointmentUpdate
                                                }
                                                leadInfo={
                                                    messageToEdit.LeadInfo
                                                }
                                                inputForm={this.props.inputForm}
                                                leadId={messageToEdit.LeadId}
                                                timeInWorkingHours={apptDataAlt => this.timeInWorkingHours(
                                                    apptDataAlt
                                                )
                                                }
                                            />
                                        )}
                                    </FormGroup>
                                </div>
                            )}

                            <Tooltip title='Replace variables' placement='left'>
                                <div
                                    className='OperatorEditBox__replace-variables'
                                    disabled={loading}
                                    onClick={() => {
                                        this.replaceDynamicVariablesWithValues()
                                    }}
                                >
                                    <ReplaceIcon />
                                </div>
                            </Tooltip>

                            <Tooltip title='Just Save and HTO' placement='left'>
                                <div
                                    className='OperatorEditBox__send HTOIgnore'
                                    disabled={
                                        messageToEdit.MessageHTML && loading
                                    }
                                    onClick={() => this.handleConfirmHTOModal()}
                                >
                                    H
                                </div>
                            </Tooltip>

                            {toolsPopupIsOpen && (
                                <div
                                    onClick={() => this.toggleToolsPopup()}
                                    className='OperatorEditBox__tools__popup-background'
                                ></div>
                            )}

                            <Tooltip title='Just save' placement='left'>
                                <div
                                    className='OperatorEditBox__send just-save'
                                    disabled={
                                        messageToEdit.MessageHTML && loading
                                    }
                                    onClick={() => {
                                        const doNotSend = true
                                        this.updateMessage(doNotSend)
                                    }}
                                >
                                    <JunkIcon />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { loading, sent, sentMessageId } = state.operatorDashboardMessage
    const {
        threadDetailsLoading,
        threadDetails,
        userDetails,
        userDetailsLoading,
    } = state.operatorDashboardDetails

    const {
        inputForm, settings, statusOn, statuses
    } = state.operatorDashboard

    let accountId
    if (
        state.operatorDashboard
        && state.operatorDashboard.historicalDialogue
        && state.operatorDashboard.historicalDialogue[0]
    ) {
        accountId = state.operatorDashboard.historicalDialogue[0].AccountId
    }

    return {
        loading,
        sent,
        sentMessageId,
        threadDetailsLoading,
        threadDetails,
        userDetails,
        userDetailsLoading,
        accountId,
        inputForm,
        settings,
        statusOn,
        statuses,
    }
}
export default connect(mapStateToProps, { updateMessage })(OperatorEditBox)
